import {
  DECODE_REQUEST,
  DECODE_SUCCESS,
  DECODE_FAILURE,
  UPDATE_HEX_VALUE,
  CLEAR_DECODER_STATE,
  TOGGLE_BIT,
  UPDATE_LOCAL_MATRIX,
  SET_DECODER_TYPE,
  INITIALIZE_WITH_DEFAULT,
  TLV_PARSE_REQUEST,
  TLV_PARSE_SUCCESS,
  TLV_PARSE_FAILURE,
  TLV_CLEAR_STATE,
  TLV_UPDATE_HEX_VALUE
} from "./actionTypes"

// Action to initiate decode request
export const decodeRequest = (data, endpoint, decoderType) => ({
  type: DECODE_REQUEST,
  payload: { data, endpoint, decoderType }
})

// Action for successful decode response
export const decodeSuccess = (response, decoderType) => ({
  type: DECODE_SUCCESS,
  payload: { response, decoderType }
})

// Action for decode failure
export const decodeFailure = (error, decoderType) => ({
  type: DECODE_FAILURE,
  payload: { error, decoderType }
})

// Action to update hex value
export const updateHexValue = (hexValue) => ({
  type: UPDATE_HEX_VALUE,
  payload: hexValue
})

// Action to clear decoder state
export const clearDecoderState = () => ({
  type: CLEAR_DECODER_STATE
})

// Action to toggle bit
export const toggleBit = (byteIndex, bitPosition, currentValue, hexValue, decoderType) => ({
  type: TOGGLE_BIT,
  payload: { byteIndex, bitPosition, currentValue, hexValue, decoderType }
})

// Action to update local matrix data
export const updateLocalMatrix = (matrixData) => ({
  type: UPDATE_LOCAL_MATRIX,
  payload: matrixData
})

// Action to set decoder type
export const setDecoderType = (decoderType) => ({
  type: SET_DECODER_TYPE,
  payload: decoderType
})

// Action to initialize with default value
export const initializeWithDefault = (data, endpoint, decoderType) => ({
  type: INITIALIZE_WITH_DEFAULT,
  payload: { data, endpoint, decoderType }
})

// TLV specific actions
export const tlvParseRequest = (data, isCustomTlv) => ({
  type: TLV_PARSE_REQUEST,
  payload: { data, isCustomTlv }
})

export const tlvParseSuccess = (response) => ({
  type: TLV_PARSE_SUCCESS,
  payload: response
})

export const tlvParseFailure = (error) => ({
  type: TLV_PARSE_FAILURE,
  payload: error
})

export const tlvClearState = () => ({
  type: TLV_CLEAR_STATE
})

export const tlvUpdateHexValue = (hexValue) => ({
  type: TLV_UPDATE_HEX_VALUE,
  payload: hexValue
})
